import type { TFunction } from 'i18next';
import type { OperatorType } from '../OperatorChip.tsx';

export const getOperatorText = (operator: OperatorType, t: TFunction): string => {
  switch (operator) {
    case 'AND':
      return t('and');
    case 'OR':
      return t('or');
    case 'EXCLUDE':
      return t('excludes');
    default:
      return operator;
  }
};
